<template lang="pug">
b-taginput(
  v-model="selected"
  :allow-new="allowNew"
  :data="options"
  :loading="settings.loading"
  :field="field"
  :placeholder="placeholder"
  :maxtags="maxtags"
  :icon="icon"
  type="is-primary"
  @add="add"
  @remove="remove"
  @typing="getOptions"
  @input="input"
  expanded
  autocomplete
)
</template>

<script>
import { mapGetters } from 'vuex';
import { SEARCH } from '@/utils/http';
import * as getters from '@/store/types/getters';

export default {
  name: 'elasticsearch-multiselect',
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
    }),
  },
  created() {
    if (this.value && this.value !== undefined) {
      this.prepopulate(this.value);
    }
  },
  data() {
    return {
      options: [],
      selected: [],
      settings: {
        loading: false,
      },
    };
  },
  methods: {
    add(val) {
      this.$emit('add', val);
    },
    getOptions(query) {
      this.settings.loading = true;
      SEARCH.post(`/${this.index}/_search`, {
        suggest: {
          suggestions: {
            text: query,
            completion: {
              field: 'suggest',
              contexts: {
                account_id: this.account.id,
              },
            },
          },
        },
      })
        .then(({ data }) => {
          const results = data.suggest.suggestions;
          if (results.length > 0) {
            const options = results[0].options;
            this.options = _.map(options, '_source');
          } else {
            this.options = [];
          }
          this.settings.loading = false;
        })
        .catch(() => {
          this.settings.loading = false;
        });
    },
    input(value) {
      if (_.isArray(value)) {
        const ids = value.map((v) => {
          if (_.isObject(v)) {
            return v.id;
          }
          return v;
        });
        this.$emit('input', ids);
      } else {
        this.$emit('input', []);
      }
    },
    async prepopulate(value) {
      this.settings.loading = true;
      const payload = {
        query: {
          bool: {
            must: [],
          },
        },
      };
      if (_.isArray(value)) {
        payload.query.bool.must.push({
          terms: { id: value },
        });
      } else {
        payload.query.bool.must.push({
          match: { id: value },
        });
      }
      const { data } = await SEARCH.post(`/${this.index}/_search`, payload);
      this.selected = _.map(data.hits.hits, '_source');
      this.settings.loading = false;
    },
    remove(val) {
      this.$emit('remove', val);
    },
  },
  props: {
    allowNew: {
      type: Boolean,
      default: false,
    },
    value: {},
    field: {
      type: String,
    },
    icon: {
      type: String,
      default: 'label',
    },
    index: {
      type: String,
    },
    maxtags: {
      type: Number,
    },
    placeholder: {
      type: String,
    },
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/form/ElasticsearchMultiselect.vue